export default __webpack_public_path__ + "static/media/grid_off_24px_outlined.921c97d6.svg";